import { component, html, virtual } from '@pionjs/pion';
import { until } from 'lit-html/directives/until.js';

import styles from './styles/index.css';
import css from './main.module.css';

const initCzTracker = () => {
	const parseHostname = (hostname: string) =>
			hostname.split('.')[0].toLowerCase(),
		env = parseHostname(window.location.hostname);

	window.czTrackerConfig = {
		endpoint:
			env === 'shelves'
				? 'https://api-lose.cosmoz.com/api/v1/events'
				: 'https://api-beta-lose.cosmoz.com/api/v1/events',
	};
};

const init$ = () => {
	initCzTracker();

	return Promise.all([
		import('./root.js'),
		import('./config').then(({ config$ }) => config$()),
	]).then(
		([{ Root }, config]) =>
			html`<config-provider .value=${config}>
				${virtual(Root)({ config })}
			</config-provider>`,
		(e) =>
			html`<div class="failure">
				<b>Failed to initializing application:</b>
				<pre>${e.message}</pre>
			</div>`,
	);
};

const Mp = () => until(init$(), html`<cz-spinner />`);

customElements.define('shelves-main', component(Mp, { styleSheets: [css] }));

document.body.appendChild(document.createElement('shelves-main'));

document.adoptedStyleSheets = [styles];
